import { useQuery } from '@tanstack/react-query';

import type {
  AgentApiCandidateMailsIndex,
  AgentApiCandidateMailsRecord,
} from '@/types/serializers';

import { scheduledRefetchInterval } from '../lib/scheduledAt';

export default function useFetchCandidateMails() {
  return useQuery<AgentApiCandidateMailsRecord[]>({
    queryKey: ['candidateMails'],
    queryFn: async () => {
      const response = await fetch('/agent/api/candidate_mails');
      if (!response.ok) {
        throw new Error('候補者メールの取得に失敗しました。');
      }
      const data: AgentApiCandidateMailsIndex = await response.json();
      return data.records;
    },
    refetchInterval: (query) => {
      const hasPendingMail = query.state.data?.some(
        (mail) => mail.status === 'queued' || mail.status === 'processing'
      );
      if (hasPendingMail) return 3000;
      return scheduledRefetchInterval(
        (query.state.data ?? [])
          .filter((mail) => mail.status === 'scheduled')
          .map((mail) => mail.scheduled_at)
      );
    },
  });
}
